import React from 'react';
import { Gem, Star, TrendingUp } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import BentoWidgetCard, { WidgetQuestion } from '../BentoWidgetCard';
import { getPointsEconomyData } from '../../../../utils/aiBriefingsData';
interface EconomiaPuntiWidgetProps {
  onHide?: () => void;
  onAsk?: (question: string) => void;
}
const EconomiaPuntiWidget: React.FC<EconomiaPuntiWidgetProps> = ({
  onHide,
  onAsk
}) => {
  const data = getPointsEconomyData();
  const questions: WidgetQuestion[] = [{
    id: '1',
    text: 'Bilancio punti sostenibile?'
  }, {
    id: '2',
    text: 'Principali fonti e utilizzi?'
  }];
  return <BentoWidgetCard id="economia-punti" title="Economia Punti" size="M" lastUpdated="5 min fa" questions={questions} onHide={onHide} onAsk={onAsk} data-id="element-1341">
      <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-1342">
        <div className="bg-gray-50 rounded-lg p-3" data-id="element-1343">
          <div className="flex items-center gap-2 mb-2" data-id="element-1344">
            <Gem className="h-4 w-4 text-gray-500" data-id="element-1345" />
            <p className="text-xs font-medium text-gray-700" data-id="element-1346">Diamond</p>
          </div>
          <p className="text-xs text-gray-600" data-id="element-1347">
            Guadagnati: {data.diamond.earned.toLocaleString()}
          </p>
          <p className="text-xs text-gray-600" data-id="element-1348">
            Spesi: {data.diamond.spent.toLocaleString()}
          </p>
          <p className="text-sm font-bold text-green-600 mt-1" data-id="element-1349">
            Netti: +{data.diamond.net.toLocaleString()}
          </p>
        </div>

        <div className="bg-gray-50 rounded-lg p-3" data-id="element-1350">
          <div className="flex items-center gap-2 mb-2" data-id="element-1351">
            <Star className="h-4 w-4 text-gray-500" data-id="element-1352" />
            <p className="text-xs font-medium text-gray-700" data-id="element-1353">Star</p>
          </div>
          <p className="text-xs text-gray-600" data-id="element-1354">
            Guadagnati: {data.star.earned.toLocaleString()}
          </p>
          <p className="text-xs text-gray-600" data-id="element-1355">
            Spesi: {data.star.spent.toLocaleString()}
          </p>
          <p className="text-sm font-bold text-green-600 mt-1" data-id="element-1356">
            Netti: +{data.star.net.toLocaleString()}
          </p>
        </div>
      </div>

      <div className="h-32 mb-4" data-id="element-1357">
        <ResponsiveContainer width="100%" height="100%" data-id="element-1358">
          <LineChart data={data.diamond.trend} data-id="element-1359">
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" data-id="element-1360" />
            <XAxis dataKey="date" stroke="#6B7280" fontSize={10} hide data-id="element-1361" />
            <YAxis stroke="#6B7280" fontSize={10} data-id="element-1362" />
            <Tooltip contentStyle={{
            backgroundColor: '#FFFFFF',
            border: '1px solid #E5E7EB',
            borderRadius: '0.5rem',
            fontSize: '12px'
          }} data-id="element-1363" />
            <Legend wrapperStyle={{
            fontSize: '10px'
          }} data-id="element-1364" />
            <Line type="monotone" dataKey="value" stroke="#6B7280" strokeWidth={2} dot={false} name="Diamond netti" data-id="element-1365" />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="space-y-2" data-id="element-1366">
        <p className="text-xs font-semibold text-gray-900" data-id="element-1367">Top Fonti</p>
        {data.topSources.slice(0, 3).map((source, index) => <div key={index} className="flex items-center justify-between text-xs" data-id="element-1368">
            <span className="text-gray-700" data-id="element-1369">{source.label}</span>
            <span className="font-medium text-gray-900" data-id="element-1370">
              {source.value.toLocaleString()}
            </span>
          </div>)}
      </div>
    </BentoWidgetCard>;
};
export default EconomiaPuntiWidget;